module.exports = "h4 {\n\tfont-weight: bold;\n\tmargin-top: 1rem;\n}"